import React from "react";
import { Skeleton } from "@/components/ui/skeleton";

export const RAG_BG = { red: "bg-red-600", amber: "bg-amber-500", green: "bg-emerald-600", grey: "bg-slate-300" };
export const RAG_TEXT = { red: "text-red-700", amber: "text-amber-700", green: "text-emerald-700", grey: "text-slate-500" };
export const RAG_LABEL = { red: "Red", amber: "Amber", green: "Green", grey: "Grey" };
export const RAG_ORDER = { red: 0, amber: 1, green: 2, grey: 3 };
export const pct = (v) => (v === null || v === undefined ? "—" : `${Math.round(v)}%`);
export const fmt = (v) => (v === null || v === undefined ? "—" : Number(v).toLocaleString("en-IN"));
export const thisMonth = () => new Date().toISOString().slice(0, 7);
export const fyOf = (m) => { const y = +m.slice(0, 4), s = +m.slice(5, 7) >= 4 ? y : y - 1; return `FY ${s}-${String(s + 1).slice(2)}`; };
export const fyStart = (fy) => `${fy.slice(3, 7)}-04`;
export const fyEnd = (fy) => `${+fy.slice(3, 7) + 1}-03`;
export const fyOptions = () => { const cur = +fyOf(thisMonth()).slice(3, 7); return [cur - 2, cur - 1, cur, cur + 1].map(s => `FY ${s}-${String(s + 1).slice(2)}`); };

export const Dot = ({ rag, testId }) => (
  <span className={`inline-block w-2.5 h-2.5 rounded-full shrink-0 ${RAG_BG[rag] || RAG_BG.grey}`} data-testid={testId} title={RAG_LABEL[rag] || "Grey"} />
);

export const ProgressBar = ({ value, marker, rag, testId }) => (
  <div className="relative h-2 rounded-full bg-slate-100 w-full" data-testid={testId}>
    {value != null && <div className={`absolute inset-y-0 left-0 rounded-full ${RAG_BG[rag] || "bg-slate-400"}`} style={{ width: `${Math.min(100, value)}%` }} />}
    {marker != null && <div className="absolute -top-1 -bottom-1 w-0.5 bg-slate-700" style={{ left: `${Math.min(100, marker)}%` }} title={`Time elapsed ${Math.round(marker)}%`} />}
  </div>
);

export const Kpi = ({ label, value, sub, tone = "", testId }) => (
  <div className="rounded-lg border border-slate-200 bg-white px-4 py-3" data-testid={testId}>
    <div className="text-[11px] uppercase tracking-wider text-slate-500">{label}</div>
    <div className={`text-2xl font-bold font-mono mt-0.5 ${tone}`}>{value}</div>
    {sub && <div className="text-xs text-slate-500 truncate">{sub}</div>}
  </div>
);

export const Skel = ({ rows = 4, h = "h-10" }) => (
  <div className="space-y-2" data-testid="loading-skeleton">{Array.from({ length: rows }).map((_, i) => <Skeleton key={i} className={`${h} w-full`} />)}</div>
);

export const RagChip = ({ i }) => (
  <span className={`inline-flex items-center gap-1 text-xs ${RAG_TEXT[i.rag]}`}><Dot rag={i.rag} />{i.status_label || RAG_LABEL[i.rag]}</span>
);
